.wrapper {
  background: #f2ede1;
  padding: 24px 20px 0 20px;

  ul {
    list-style: none;
  }

  li {
    color: #221e1a;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;

    span {
      font-weight: 700;
    }
  }
}

.list {
  padding-left: 45px;
  position: relative;

  .item1 {
    color: #7a7670;
    margin-bottom: 19px;
    position: relative;
  }

  .item2 {
    margin-bottom: 19px;
    position: relative;
  }

  .item1::after,
  .item2::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 5;
  }

  .item1::after {
    background: url(./img/icn1.png) no-repeat;
    background-size: contain;
    background-position: center;
    width: 28px;
    height: 28px;
    top: 0;
    left: -42px;
  }

  .item2::after {
    background: url(./img/icn2.png) no-repeat;
    background-size: contain;
    background-position: center;
    width: 34px;
    height: 34px;
    left: -45px;
    // The guide name wraps to two lines at design width and to one on wider screens,
    // so centre the lock on the row instead of pinning it to a line.
    top: 50%;
    transform: translateY(-50%);
  }
}

.listImg {
  position: absolute;
  top: -3px;
  left: 0;
  width: 34px;
  object-fit: contain;
}

.list2 {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;

  li {
    position: relative;
  }

  li:after {
    content: '';
    display: block;
    width: 16px;
    height: 18px;
    background: url(./img/icn3.png) no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    top: 0;
    left: -20px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      background: #2a2928;
    }

    .item1,
    .item2,
    .list2 li {
      color: #fffbf2;
    }

    .item2::after {
      background: url(./img/icn2Dark.png) no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
}
